import { useContext } from "react";
import { UNSAFE_RouteContext } from "react-router-dom";

export const useRouteBasePath = () => {
  const routeContext = useContext(UNSAFE_RouteContext);
  const baseMatch = routeContext.matches[routeContext.matches.length - 1];
  return baseMatch.pathnameBase;
};
